<template>
  <div
    class="rounded-2xl shadow-xl bg-white overflow-hidden border border-orange-100"
  >
    <div class="px-7 pt-7 pb-5">
      <div class="flex items-center gap-3">
        <img :src="logoUrl" alt="Respina" class="h-8 w-auto" />
        <div>
          <h1 class="text-xl font-extrabold text-gray-900 leading-tight">
            Sign in
          </h1>
        </div>
      </div>
    </div>

    <form @submit.prevent="submit" class="px-7 pb-7">
      <div
        v-if="error"
        class="mb-4 p-3 rounded-xl bg-red-50 border border-red-100 text-red-700 text-sm"
      >
        {{ error }}
      </div>

      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-semibold mb-2"
          >Email</label
        >
        <div class="relative">
          <i
            class="fas fa-envelope absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
          ></i>
          <input
            v-model="email"
            type="email"
            required
            class="w-full h-12 pl-11 pr-4 border-2 border-gray-200 rounded-xl focus:border-respina-primary focus:ring-2 focus:ring-orange-100 outline-none"
            placeholder="you@example.com"
          />
        </div>
      </div>

      <div class="mb-6">
        <label class="block text-gray-700 text-sm font-semibold mb-2"
          >Password</label
        >
        <div class="relative">
          <i
            class="fas fa-lock absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
          ></i>
          <input
            v-model="password"
            type="password"
            required
            class="w-full h-12 pl-11 pr-4 border-2 border-gray-200 rounded-xl focus:border-respina-primary focus:ring-2 focus:ring-orange-100 outline-none"
            placeholder="••••••••"
          />
        </div>
      </div>

      <button
        type="submit"
        class="w-full h-12 bg-respina-primary hover:bg-respina-secondary text-white font-bold rounded-xl transition-all shadow-md hover:shadow-lg disabled:opacity-50"
        :disabled="loading"
      >
        {{ loading ? "Signing in..." : "Sign in" }}
      </button>

      <p class="mt-4 text-center text-gray-600 text-sm">
        Don't have an account?
        <router-link to="/auth/register" class="text-respina-primary font-bold"
          >Create one</router-link
        >
      </p>
    </form>
  </div>
</template>

<script>
import { login } from "@/lib/auth";
import logoUrl from "@/assets/respina/logo.png";

export default {
  data() {
    return { email: "", password: "", error: null, loading: false, logoUrl };
  },
  methods: {
    async submit() {
      this.error = null;
      this.loading = true;
      try {
        await login(this.email, this.password);
        this.$router.replace("/airport-board");
      } catch (e) {
        this.error = e?.message || "Sign-in failed";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
